import { ChakraComponents as CC } from '@Modules/core/lib/chakra';

export interface IUsersProfileModuleOptionDatatable {
  idOption: string;
  labelOption: string;
  idMenuParent: string;
  access: string;
  insert: string;
  update: string;
  delete: string;
}

const columns = () => [
  {
    id: 'idOption',
    header: 'Id. Option',
    accessorKey: 'idOption',
    cell: (ctx: any) => ctx.getValue(),
  },
  {
    id: 'labelOption',
    header: 'Libellé Option',
    accessorKey: 'labelOption',
    cell: (ctx: any) => ctx.getValue(),
  },
  {
    id: 'idMenuParent',
    header: 'Id. Menu Parent',
    accessorKey: 'idMenuParent',
    cell: (ctx: any) => ctx.getValue(),
  },
  {
    id: 'access',
    header: 'Accès',
    accessorKey: 'access',
    cell: (ctx: any) => {
      // const row = ctx.row.origial;
      return (
        <CC.Box>
          <CC.Stack direction="row" spacing={2}>
            <CC.Checkbox checked={!!ctx.getValue()} />
          </CC.Stack>
        </CC.Box>
      );
    },
  },
  {
    id: 'insert',
    header: 'Insert',
    accessorKey: 'insert',
    cell: (ctx: any) => {
      // const row = ctx.row.origial;
      return (
        <CC.Box>
          <CC.Stack direction="row" spacing={2}>
            <CC.Checkbox checked={!!ctx.getValue()} />
          </CC.Stack>
        </CC.Box>
      );
    },
  },
  {
    id: 'update',
    header: 'Maj',
    accessorKey: 'update',
    cell: (ctx: any) => {
      // const row = ctx.row.origial;
      return (
        <CC.Box>
          <CC.Stack direction="row" spacing={2}>
            <CC.Checkbox checked={!!ctx.getValue()} />
          </CC.Stack>
        </CC.Box>
      );
    },
  },
  {
    id: 'delete',
    header: 'Supp',
    accessorKey: 'delete',
    cell: (ctx: any) => {
      // const row = ctx.row.origial;
      return (
        <CC.Box>
          <CC.Stack direction="row" spacing={2}>
            <CC.Checkbox checked={!!ctx.getValue()} />
          </CC.Stack>
        </CC.Box>
      );
    },
  },
];

export const UsersProfileModuleOptionDatatableMeta = {
  columns,
};
